import { MAIN_PROFILE_ACTION } from '../../constants/actions'

const changeMainState = (property, value) => ({
  type: MAIN_PROFILE_ACTION.CHANGE_STATE,
  payload: {
    property,
    value
  }
})

const getTiers = () => ({
  type: MAIN_PROFILE_ACTION.GET_TIERS
})

export { changeMainState, getTiers }
